import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const MountingIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 0c.837 0 1.503.733 1.401 1.584l4.858 3.65H24V24H0V5.234h5.741l4.858-3.65A1.414 1.414 0 0 1 12 0ZM7.075 19.93c-.975-.979-2.651-.278-2.651 1.1v1.555h3.105V21.03c0-.415-.161-.806-.454-1.1Zm7.53 0c-.976-.979-2.652-.278-2.652 1.1v1.555h3.106V21.03c0-.415-.162-.806-.455-1.1Zm7.983-13.282H1.412v15.937h1.6V21.03c0-.942.44-1.782 1.125-2.327-1.61-1.631-.452-4.415 1.84-4.415 2.296 0 3.446 2.785 1.84 4.414a2.956 2.956 0 0 1 1.124 2.328v1.556h1.6V21.03c0-.942.44-1.782 1.125-2.327-1.61-1.631-.451-4.415 1.84-4.415 2.296 0 3.446 2.785 1.84 4.414a2.956 2.956 0 0 1 1.125 2.328v1.556h6.117V6.648ZM5.976 15.701a1.179 1.179 0 0 0 0 2.358 1.179 1.179 0 0 0 0-2.358Zm7.53 0a1.179 1.179 0 0 0 0 2.358 1.179 1.179 0 0 0 0-2.358Zm4.141-7.159a2.235 2.235 0 0 1 2.686.366 2.247 2.247 0 0 1 0 3.17l-2.68 2.672-2.69-2.67a2.248 2.248 0 0 1-.002-3.172 2.235 2.235 0 0 1 2.686-.366Zm1.688 1.366a.824.824 0 0 0-1.167 0l-.52.522-.522-.522a.824.824 0 0 0-1.167 0 .829.829 0 0 0 0 1.17l1.692 1.679 1.685-1.681a.828.828 0 0 0-.001-1.168Zm-6.78-7.193c-.362.155-.764.149-1.11 0l-3.35 2.519h7.81Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

MountingIcon.propTypes = propTypes;

export default MountingIcon;
